import React, {Component} from 'react';
import styles from './TagListItem.css';
import {TypeTagListItem} from "../../constants/consts-prop-types"
import PropTypes from "prop-types"

class TagListItem extends Component {
  static propTypes = {
    data: TypeTagListItem.isRequired,
    isSelected: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired
  }

  render() {
    const {id, title, slug} = this.props.data

    return (
      <span className={styles.TagListItem}>
        <input
          id={id}
          readOnly
          aria-label={`Filter by ${title}`}
          type="checkbox"
          onClick={() => this.props.onToggle(slug)}
          className={styles.checkbox}
          checked={this.props.isSelected}
        />
        <span className={styles.label} dangerouslySetInnerHTML={{__html: title}}/>
        <span className={styles.pipe}>|</span>
      </span>
    );
  }
}

export default TagListItem;



// WEBPACK FOOTER //
// ./src/components/TagListItem/TagListItem.js